import React from "react";

import { ErrorBoundary, FallbackProps } from "react-error-boundary";

export const ClientErrorBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
  function fallbackRender({ error, resetErrorBoundary }: FallbackProps) {
    return (
      <div className={"container mx-auto"}>
        <pre
          onClick={() => {
            console.log(error);
          }}
        >
          {error.message}
        </pre>
      </div>
    );
  }

  return <ErrorBoundary fallbackRender={fallbackRender}>{children}</ErrorBoundary>;
};
